<div fxLayout="column" fxLayoutGap="10px" class="desktop" *ngIf="screenMode==='desktop'">
    <div fxLayout="row">
        <select name="options" (change)="selectOption($event.target.value)">
            <option [value]="option.value" *ngFor="let option of options">
                {option.value, select, mesCurta {Más corta} evitaPeatges {Evitar peajes} mesRapidaTrafic {Más rápida considerando tráfico}}
            </option>
        </select>
    </div>


    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div cdkDropList class='waypoint-list' (cdkDropListDropped)="drop($event)" fxFlex="90%">
            <div class="waypoint-box" *ngFor="let waypoint of waypoints; let i = index" >
                <div class="letterCircle" cdkDrag>{{lletres[i]}} </div>
                <input #waypoint i18n-placeholder placeholder="Introduce dirección" id="{{waypoint.id}}" (click)="checkAutocomplete()"/>
                <span class="delete-button" (click)=deleteWaypoint(waypoint) *ngIf="waypoints.length >  2 && i > 1 "><img src="assets/img/close.svg"></span>
            </div>
        </div>
        <div  fxLayoutAlign="center center"  *ngIf="3 > waypoints.length">
            <img (click)="swapWaypoints()" class="change-waypoint"  src="assets/img/changeWaypoints.svg" alt="">
        </div>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="add-waypoint" *ngIf="waypoints.length < 8" (click)="addWaypoint()" fxLayout="row"  fxLayoutGap="5px">
            <div class="add-button"></div><span i18n>Añadir ubicación</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <div class="opcions-fuel" (click)="openFuelDialog()"><img src="assets/img/opcionsFuel.svg" alt="Opcions combustible"></div>
            <div (click)="emitCalculateEvent()"  class="calculate-route" i18n>
                Calcular ruta
            </div>
        </div>
        
    </div>
    

</div>




<div fxLayout="column" fxLayoutGap="10px" class="responsive-landscape-container" *ngIf="screenMode==='landscape'">
    <div fxLayout="row">
        <select name="options" (change)="selectOption($event.target.value)">
            <option [value]="option.value" *ngFor="let option of options" i18n>
                {option.value, select, mesCurta {Más corta} evitaPeatges {Evitar peajes} mesRapidaTrafic {Más rápida considerando tráfico}}
            </option>
        </select>
    </div>


    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div cdkDropList class='waypoint-list' (cdkDropListDropped)="drop($event)" fxFlex="90%">
            <div class="waypoint-box" *ngFor="let waypoint of waypoints; let i = index" >
                <div class="letterCircle" cdkDrag>{{lletres[i]}} </div>
                <input #waypoint i18n-placeholder placeholder="Introduce dirección" id="{{waypoint.id}}" (click)="checkAutocomplete()"/>
                <span class="delete-button" (click)=deleteWaypoint(waypoint) *ngIf="waypoints.length >  2 && i > 1 "><img src="assets/img/close.svg"></span>
            </div>
        </div>
        <div  fxLayoutAlign="center center"  *ngIf="3 > waypoints.length">
            <img (click)="swapWaypoints()" class="change-waypoint"  src="assets/img/changeWaypoints.svg" alt="">
        </div>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="add-waypoint" *ngIf="waypoints.length < 8" (click)="addWaypoint()" fxLayout="row"  fxLayoutGap="5px">
            <div class="add-button-responsive"><img src="assets/img/addButton.svg" alt="Afegir parada"></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <div class="opcions-fuel" (click)="openFuelDialog()"><img src="assets/img/opcionsFuel.svg" alt="Opcions combustible"></div>
            <div (click)="emitCalculateEvent()"  class="calculate-route" i18n>
                Calcular ruta
            </div>
        </div>
        
    </div>
    

</div>






<div fxLayout="column" fxLayoutGap="10px" class="responsive-container" *ngIf="screenMode==='portrait'">
    <div fxLayout="row">
        <select name="options" (change)="selectOption($event.target.value)">
            <option [value]="option.value" *ngFor="let option of options" i18n>
                {option.value, select, mesCurta {Más corta} evitaPeatges {Evitar peajes} mesRapidaTrafic {Más rápida considerando tráfico}}
            </option>
        </select>
    </div>


    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div cdkDropList class='waypoint-list' (cdkDropListDropped)="drop($event)" fxFlex="90%">
            <div class="waypoint-box" *ngFor="let waypoint of waypoints; let i = index" >
                <div class="letterCircle" cdkDrag>{{lletres[i]}} </div>
                <input #waypoint i18n-placeholder placeholder="Introduce dirección" id="{{waypoint.id}}" (click)="checkAutocomplete()"/>
                <span class="delete-button" (click)=deleteWaypoint(waypoint) *ngIf="waypoints.length >  2 && i > 1 "><img src="assets/img/close.svg"></span>
            </div>
        </div>
        <div  fxLayoutAlign="center center"  *ngIf="3 > waypoints.length">
            <img (click)="swapWaypoints()" class="change-waypoint"  src="assets/img/changeWaypoints.svg" alt="">
        </div>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div class="add-waypoint" *ngIf="waypoints.length < 8" (click)="addWaypoint()" fxLayout="row"  fxLayoutGap="5px">
            <div class="add-button-responsive"><img src="assets/img/addButton.svg" alt="Afegir parada"></div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <div class="opcions-fuel" (click)="openFuelDialog()"><img src="assets/img/opcionsFuel.svg" alt="Opcions combustible"></div>
            <div (click)="emitCalculateEvent()"  class="calculate-route" i18n>
                Calcular Ruta
            </div>
        </div>
        
    </div>
    

</div>

    
    

